import styled from 'styled-components'
import Image from '../../Image/Image'
import pxToRem from '../../../utils/pxToRem'
import Video from '../../Video/Video'

export const ImageMarginEnum = Object.freeze({
  withoutText: 'withoutText',
})

export const StyledCarrouselMedia = styled.div`
  flex-direction: column;
  display: flex !important;
  img,
  video {
    width: 100%;
    max-height: ${pxToRem(195)};
    position: relative;
  }
`
export const StyledParagraph = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  padding-top: ${({ variant }) =>
    variant === ImageMarginEnum.withoutText ? '' : pxToRem(10)};
`
